<template>
  <div class="todo-users">
    <div class="buttons">
      <el-button type="warning" :loading="isLoading" round @click="download">
        {{ $t('downloadExcel') }}
      </el-button>
    </div>
    <el-row type="flex" class="todo-provider">
      <el-col>
        <el-collapse v-model="activeName" @change="handleChange">
          <el-collapse-item title="Filtros" name="1">
            <el-alert
              title="Por defecto los items están ordenados por la fecha de creación de más nuevo a más antiguo."
              type="success"
            />
            <el-divider />
            <el-checkbox v-model="createdToday" @change="handleCreatedToday">
              Creados hoy
            </el-checkbox>
            <el-checkbox v-model="orderAtoZ" @change="handleAToZ">
              Ordenar A a la Z
            </el-checkbox>
            <el-input v-if="role === 'ServiceProvider'" v-model="searchByName" placeholder="Search by Name" type="text" autocomplete="off"
            @input="searchByNameFunc" class="search-by-name"/>
          </el-collapse-item>
          <span v-if="ifLoadingData === true" class="text-center">Loading Data...</span><br>
        </el-collapse>
      </el-col>
    </el-row>
    <div v-if="!listLoading" class="scrollbar">
      <div v-for="user in list" :key="user.id" class="todo-users-row">
        <todo-provider v-if="role === 'ServiceProvider'" :user="user" />
        <todo-customer v-if="role === 'Customer'" :user="user" />
      </div>
      <template v-if="role === 'Services'">
        <div v-for="service in services" :key="service.id" class="todo-users-row">
          <todo-service :service="service" />
        </div>
      </template>
    </div>

    <todo-pagination
      :total="total"
      :page-size="listQuery.per_page"
      @current-change="changePage"
    />
  </div>
</template>

<script>
  import { getUsers } from '@/api/users'
  import { getExcel } from '@/api/excel'
  import { getServices } from '@/api/services'
  import TodoProvider from './Provider.vue'
  import TodoCustomer from './Customer.vue'
  import TodoService from './Service.vue'
  import TodoPagination from '@/components/Pagination.vue'

  export default {
    components: {
      'todo-provider': TodoProvider,
      'todo-customer': TodoCustomer,
      'todo-service': TodoService,
      'todo-pagination': TodoPagination
    },

    props: {
      role: String
    },

    data() {
      return {
        activeName: 'Customers',
        isLoading: false,
        createdToday: false,
        orderAtoZ: false,
        listLoading: true,
        listQuery: {
          page: 1,
          // eslint-disable-next-line @typescript-eslint/camelcase
          per_page: 10
        },
        total: 0,
        list: [],
        services: [],
        servicesQuery: {
          page: 1,
          // eslint-disable-next-line @typescript-eslint/camelcase
          per_page: 10
        },
        originalList: [],
        searchByName: '',
        timerId: '',
        ifLoadingData: false
      }
    },

    created() {
      if (!this.role) {
        this.role = 'ServiceProvider'
      }
      this.getList()
      this.getServices()
    },

    methods: {
      handleChange(val) {
        // this.sort()
      },
      handleCreatedToday() {
        this.listQuery.createdToday = this.createdToday
        this.getList()
      },
      handleAToZ() {
        this.listQuery.abc = this.orderAtoZ
        this.getList()
      },
      async getList() {
        if (this.role !== 'Services') {
          this.listLoading = true
          const { data } = await getUsers(this.role, this.listQuery)
          this.list = data.data
          this.total = data.meta.total
          this.listLoading = false
        }
      },

      async download() {
        this.isLoading = true
        this.listLoading = true
        const { data } = await getExcel(this.role, {})
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'report.xlsx')
        document.body.appendChild(link)
        link.click()
        this.isLoading = false
      },

      async getServices() {
        this.listLoading = true
        const response = await getServices('paid', this.servicesQuery)
        this.services = response.data.data.timeslots
        this.listLoading = false
      },

      changePage(page) {
        this.listQuery.page = page

        this.getList()
      },
      /** added */
      handleName() {
        this.listQuery.searchName = this.searchByName
        this.getList()
        this.ifLoadingData = false
      },
      searchByNameFunc() {
        this.ifLoadingData = true
        this.debounceFunction(this.handleName, 1000)
      },
      debounceFunction(func, delay) {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(func, delay)
        // setTimeout(func, delay)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .todo-users {
    //position: absolute;
    //top: 110px;
    //right: 50px;
    //bottom: 30px;
    //left: 235px;
    //z-index: 500;

    .todo-users-row {
      border-bottom: 1px solid $border-color-light;
      padding: 10px 0;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: black;
    }
    .buttons {
      text-align: right;
      margin-bottom: 15px;
      button{
        max-width: 250px;
      }
    }
    .search-by-name{
      margin-left: 30px
    }
  }
</style>
